import { gql } from "@apollo/client";import { useQuery } from "@apollo/client/react";

export const useTerminosAll = () => {

  const QTermino = gql`
        query query {
            terminosAll {
              success,
              error,
              valorEsperado {
                idTermino,
                vigenciaDesde,
                vigenciaHasta,
                version
              }
            }
          }`;

  const { loading, error, data } = useQuery(
    QTermino,
    { fetchPolicy: 'cache-and-network' }
  );

  return { data, loading, error };
};